export class InvalidTokenError extends Error {
  //
}

export class ExpiredAuthSessionError extends Error {
  //
}
